export default "__VITE_ASSET__98a65b28__"